import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UPDATE } from 'react-admin';
import Tooltip from '@material-ui/core/Tooltip';
// Use material UI button because Tooltip doesn't work with react-admin Button
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';

import dataProvider from '../../dataProvider';

class SendCampaignToMailchimp extends Component {
  state = {
    isSending: false,
    isSent: false,
    showDialog: false,
    content: `Are you sure you want to send the campaign to the selected audience 
      ${this.props.record.members ?
      `(${this.props.record.members.length})` :
      ''}?`,
    loading: false,
    confirmation: false,
  };

  handleClick = async () => {
    this.setState({
      isSending: true,
    });
    const { resource, record } = this.props;

    dataProvider(UPDATE, resource, {
      id: record.id,
      action: 'send-to-mailchimp',
      resource,
    }).then(() => {
      this.setState({
        isSending: false,
        isSent: true,
        loading: false,
        content: 'Campaign successfully sent.',
      });
    })
      .catch((e) => {
        let localContent = e;
        if (e.body) {
          localContent = `Error:${JSON.parse(e.body).error.message}`;
        }

        this.setState({
          showDialog: true,
          content: localContent,
          loading: false,
        });
      });
  }

  openDialog = () => {
    this.setState({ showDialog: true });
  };

  closeDialog = () => {
    this.setState({ showDialog: false });
  };

  confirmSendingCampaign = () => {
    this.handleClick();
    this.setState({
      loading: true,
      confirmation: true,
    });
  };

  render() {
    // Pull out props that Button doesn't need
    const {
      showDialog,
      content,
      loading,
      confirmation,
    } = this.state;
    const { sendToMailchimp, ...rest } = this.props;
    const {
      offerId,
      status,
      isConditionalOffer,
      mailChimpCampaignId,
    } = this.props.record;

    let disabled = false;
    let tooltipTitle = false;
    if (status === 'sent' || this.state.isSent) {
      disabled = true;
      tooltipTitle = 'Campaign is already sent';
    } else if (status !== 'created') {
      disabled = true;
      tooltipTitle = 'Campaign status is not "created"';
    } else if (!offerId) {
      disabled = true;
      tooltipTitle = 'Campaign need an offer association';
    } else if (!isConditionalOffer) {
      disabled = true;
      tooltipTitle = 'Offer associated with campaign is not conditional';
    } else if (!mailChimpCampaignId) {
      disabled = true;
      tooltipTitle = 'This campaign has no Mailchimp Id';
    } else if (this.state.isSending) {
      disabled = true;
      tooltipTitle = 'Sending campaign';
    } // else if (!hasSubscribers) {
    //   disabled = true;
    //   tooltipTitle = 'Campaign has no subscribers';
    // }

    // When Button is disabled the Tooltip hover doesn't work
    // so explictly "open" the Tooltip
    return (
      <Fragment>
        <Tooltip title={tooltipTitle} open={disabled}>
          <Button
            onClick={this.openDialog}
            disabled={disabled}
            color="primary"
            size="small"
            {...rest}
          >
            Send Campaign
          </Button>
        </Tooltip>
        <Dialog fullWidth open={showDialog} maxWidth="xs" onClose={this.closeDialog} aria-label="Campaign status">
          <DialogTitle>Campaign notification</DialogTitle>
          <DialogContent>
            { loading ? <CircularProgress /> : content }
          </DialogContent>
          { confirmation ?
              null :
              <DialogActions>
                <Button onClick={this.closeDialog} color="primary">
            Cancel
                </Button>
                <Button onClick={this.confirmSendingCampaign} color="primary" autoFocus>
            Send
                </Button>
              </DialogActions> }
        </Dialog>
      </Fragment>
    );
  }
}


const sendToMailchimpAction = (resource, id, meta) => ({
  type: 'SEND_CAMPAIGN_TO_MAILCHIMP',
  payload: {
    id,
    resource,
    action: 'send-to-mailchimp',
  },
  meta: {
    fetch: UPDATE,
    resource,
    refresh: true, // refresh this object
    ...meta,
  },
});


SendCampaignToMailchimp.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.string,
    offerId: PropTypes.string,
    mailChimpCampaignId: PropTypes.string,
  }).isRequired,
  sendToMailchimp: PropTypes.func.isRequired,
};

export default connect(null, {
  sendToMailchimp: sendToMailchimpAction,
})(SendCampaignToMailchimp);



// WEBPACK FOOTER //
// ./src/components/OfferCampaign/SendCampaignToMailchimp.js